export const isFeedReader = (path) => /^\/feed\/[^/]+\/?$/.test(path);
export function feedCompactTitle(compact, offset, previous) {
  if (offset <= 0) return false;
  if (offset - previous >= -0.5) return compact;
  return compact ? offset > 44 : offset > 56;
}
